import React from 'react';
import { useEndAllActiveUserSessionsMutation } from '../../../../slices/account-api.slice';
import { DeleteButton, SecondaryButton } from '@workday/canvas-kit-react/button';
import { autoId } from '@workday/upc-common';
import { ID_SESSIONS_LOG_OUT_CONFIRM_BUTTON, ID_SESSIONS_LOG_OUT_CANCEL_BUTTON } from '../../../../autoIds';
import styles from './ConfirmLogoutSessions.module.scss';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

export function ConfirmLogoutSessions({ onCloseModal }) {
    const [endAllActiveUserSessions] = useEndAllActiveUserSessionsMutation();

    const { t } = useTranslation('account');

    function endAllUserSession(e) {
        e.preventDefault();
        endAllActiveUserSessions();
    }

    return (
        <div className={classNames('settingsModalContent', styles.confirmLogoutSessions)}>
            <h1>{t('ConfirmLogoutSessions.title')}</h1>
            <h3>{t('ConfirmLogoutSessions.description')}</h3>
            <div className={styles.buttonWrapper}>
                <div>
                    <DeleteButton
                        onClick={endAllUserSession}
                        {...autoId(ID_SESSIONS_LOG_OUT_CONFIRM_BUTTON)}
                        type={'submit'}
                        size={'large'}
                        grow={false}
                        className={styles.button}>
                        {t('ConfirmLogoutSessions.confirmButton')}
                    </DeleteButton>
                </div>
                <div className={styles.cancel}>
                    <SecondaryButton
                        {...autoId(ID_SESSIONS_LOG_OUT_CANCEL_BUTTON)}
                        type={'button'}
                        size={'large'}
                        onClick={onCloseModal}
                        className={styles.button}>
                        {t('Common.cancel', { ns: 'shared' })}
                    </SecondaryButton>
                </div>
            </div>
        </div>
    );
}
